import { createApp } from 'vue';
import App from './App.vue';
import i18n from './lang';
import router from './router/index.js';
import store from './store/index.js';
import axios from 'axios';
import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css';
import { ElMessage } from 'element-plus';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import navigation from './components/navigation.vue';
import Pfooter from './components/footer.vue';
import './assets/scroll.css';

const app = createApp(App);

// 全局注册 axios
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$message = ElMessage;

// 注册插件
app
  .use(i18n)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(Toast, {
    transition: 'Vue-Toastification__bounce',
    maxToasts: 20,
    newestOnTop: true
  });

// 全局组件
app
  .component('navigation', navigation)
  .component('Pfooter', Pfooter);

// 挂载应用
app.mount('#app');